import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { GestionProfesionalesContent } from './components/GestionProfesionalesContent';

export default function GestionProfesionales() {

    return (
        <>
            <MainContent
                component={<GestionProfesionalesContent />}
                titulo={'Administración de Profesionales'}
                noBackground
                tableMaxWidth
            />
        </>
    );
};
